<template>
    <div>
        <Mainlayout></Mainlayout>
    
        <CCol sm="12" class="bg-FAFAFA">
    
    
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <br /> <br /> <br /> <br /> <br />
                <CCard class="bg-white b-20 m-3 p-20 mb-5" style="border:none;">
                    <CRow class="m-2">
                        <CCol sm="12">
                            <h3 class="custom-40px-500 text-center mt-3">Select Your Candidate</h3>
                            <p class="custom-18px-400 text-center m-2">Subscribe to view the details and watch the interview videos of up to 25 candidates</p>
                        </CCol>
                        <CCol sm="12">
    
    
                            <table class="table table-responsive-sm table-hover table-outline mb-0 mt-3 ml-15 mr-15" style="border:none">
                                <thead class="bg-f7f7f7 b-20">
                                    <th> <label class="custom-12px-700"><input type="checkbox" class="mr-2"/>Candidate Name</label></th>
                                    <th> <label class="custom-12px-700">Role</label></th>
                                    <th><label class="custom-12px-700">Email</label></th>
                                    <th> <label class="custom-12px-700">Employee Status</label></th>
                                    <th><label class="custom-12px-700">Interview</label></th>
                                    <th><label class="custom-12px-700">Video</label></th>
                                </thead>
    
                                <tbody>
                                    <tr>
                                        <td>
                                            <input type="checkbox" class="mr-2" /><img style="max-width:30px" src="../assets/img/2-2.png" class="m-2"/>Pristia Candra
                                        </td>
                                        <td>
                                            <label class="custom-12px-700">UI UX Designer</label>
                                        </td>
                                        <td>
                                            <label class="custom-12px-700">10x viewed</label>
                                        </td>
                                        <td>
                                            <label class="custom-12px-700">12 Feedbacks</label>
                                        </td>
                                        <td>
                                            <label class="custom-12px-700">Offered</label>
                                        </td>
                                        <td>
                                            <label class="custom-border-purple p-2 mr-5 text-white">Watch</label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input type="checkbox" class="mr-2" /><img style="max-width:30px" src="../assets/img/1-2.png" class="m-2"/>Hanna Baptista
                                        </td>
                                        <td>
                                            <label class="custom-12px-700">Graphic Designer</label>
                                        </td>
                                        <td>
                                            <label class="custom-12px-700">10x viewed</label>
                                        </td>
                                        <td>
                                            <label class="custom-12px-700">12 Feedbacks</label>
                                        </td>
                                        <td>
                                            <label class="custom-12px-700">Offered</label>
                                        </td>
                                        <td>
                                            <label class="custom-border-purple p-2 mr-5 text-white">Watch</label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input type="checkbox" class="mr-2" /><img style="max-width:30px" src="../assets/img/2-2.png" class="m-2"/>Pristia Candra
                                        </td>
                                        <td>
                                            <label class="custom-12px-700">UI UX Designer</label>
                                        </td>
                                        <td>
                                            <label class="custom-12px-700">10x viewed</label>
                                        </td>
                                        <td>
                                            <label class="custom-12px-700">12 Feedbacks</label>
                                        </td>
                                        <td>
                                            <label class="custom-12px-700">Offered</label>
                                        </td>
                                        <td>
                                            <label class="custom-border-purple p-2 mr-5 text-white">Watch</label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input type="checkbox" class="mr-2" /><img style="max-width:30px" src="../assets/img/2-2.png" class="m-2"/>Pristia Candra
                                        </td>
                                        <td>
                                            <label class="custom-12px-700">UI UX Designer</label>
                                        </td>
                                        <td>
                                            <label class="custom-12px-700">10x viewed</label>
                                        </td>
                                        <td>
                                            <label class="custom-12px-700">12 Feedbacks</label>
                                        </td>
                                        <td>
                                            <label class="custom-12px-700">Offered</label>
                                        </td>
                                        <td>
                                            <label class="custom-border-purple p-2 mr-5 text-white">Watch</label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
    
                        </CCol>
    
                    </CRow>
                </CCard>
    <br /><br /><br />
            </CCol>
    
        </CCol>
    
        <CCol sm="12" class="p-1" style="background-size: cover;color: #fff">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" style="width: 80%;margin: auto;">
                        <div class="text-center" style="background-size: cover;border-radius: 20px;" :style="{ backgroundImage: `url(${backgroundUrNoArrow})` }">
                            <br />
                            <br /> <br /> <br />
                            <h1 class="custom-header-join text-white poppin-font text-48px mt-5">Subscribe Now for Free</h1>
                            <br />
                            <label class="custom-header-join-sub text-white">
                                        Sign up now for free and take the first step toward landing your dream job!
                                                                        </label>
                            <br />
                            <br /> <br /> <br />
                            <CButton class="button-Explore"><span class="ml-2 mr-2">Inquire</span></CButton>
                            <br />
                            <br /> <br /> <br />
                            <br />
                        </div>
                    </CCol>
                </div>
                <br /><br /><br />
            </CCol>
    
            <div v-if="isLanguagePopupVisible2" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup1" />
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width:100px" src="../assets/img/success.png" />
                        <h3 class="custom-32px-500">Success!</h3>
                        <h3 class="custom-18px text-center">Thank you for reaching out to us by completing the form.
                        </h3>
                    </div>
    
                </div>
            </div>
    
    
        </CCol>
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            isLanguagePopupVisible2: false,
            Name: "",
            Email: "",
            Phone: "",
            Help: "",

        };
    },
    created() {},
    methods: {
        insertHelp() {
            const formData = new FormData();
            formData.append("name", this.Name);
            formData.append("email", this.Email);
            formData.append("phone", this.Phone);
            formData.append("help", this.Help);


            this.$API
                .post(this.$RegisterSupport, formData, )
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {

                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {


                                this.isLanguagePopupVisible2 = true;

                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }

                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });

        },
        closePopup1() {
            this.isLanguagePopupVisible2 = false
        }
    }

};
</script>

